export default {
  patients: {
    label: 'Patients',
    patientsList: 'Liste des patients',
    viewPatients: 'Voir les patients',
    noPatients: "Il n'y a aucun patient ici, voilà donc le premier",
    viewPatient: 'Voir le patient',
    editPatient: 'Modifier le patient',
    newPatient: 'Nouveau patient',
    successfullyCreated: 'Patient créé avec succès',
    successfullyAddedNote: 'Note ajoutée avec succès',
    successfullyAddedRelatedPerson: "Ajout d'une nouvelle personne liée avec succès",
  },
}
